import en_GB from '../../date-picker/locale/en_GB';
export default en_GB;



// WEBPACK FOOTER //
// ./components/calendar/locale/en_GB.tsx